export enum LocationType {
  POINT = 'point',
  ROOM = 'poi',
  BUILDING = 'building',
  CATEGORY = 'category',
}

